import users from "./users";
import team from "./teams";
import companyUsers from "./companyUsers";
import home from "./home";
import performance from "./performance";
import companyAdmin from "./companyAdmin";
import manager from "./manager";
import leaderboard from "./leaderboard";
import coachup from "./coachup";
import compete from "./compete";
import appSettings from "./appSettings";
import companyKpis from "./companyKpis";
import modules from "./modules";
import subscription from "./subscription";
import hub from "./hub";
import notifications from "./notifications";

const slices = {
  loginUser: users,
  teams: team,
  companyUsers,
  home,
  performance,
  companyAdmin,
  manager,
  leaderboard,
  coachup,
  compete,
  appSettings,
  companyKpis,
  modules,
  subscription,
  hub,
  notifications,
};

export default slices;
